"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var FacebookBrand = function FacebookBrand(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "1024px",
    height: "1018px",
    viewBox: "0 0 1024 1018"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1024,512 C1024,229.23 794.77,0 512,0 C229.23,0 0,229.23 0,512 C0,767.554 187.231,979.37 432,1017.78 L432,660 L302,660 L302,512 L432,512 L432,399.2 C432,270.88 508.438,200 625.39,200 C681.407,200 740,210 740,210 L740,336 L675.438,336 C611.835,336 592,375.467 592,415.957 L592,512 L734,512 L711.3,660 L592,660 L592,1017.78 C836.769,979.37 1024,767.554 1024,512",
    id: "Fill-1",
    fill: "#1877F2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M711.3,660 L734,512 L592,512 L592,415.957 C592,375.467 611.835,336 675.438,336 L740,336 L740,210 C740,210 681.407,200 625.39,200 C508.438,200 432,270.88 432,399.2 L432,512 L302,512 L302,660 L432,660 L432,1017.78 C458.067,1021.87 484.784,1024 512,1024 C539.216,1024 565.933,1021.87 592,1017.78 L592,660 L711.3,660",
    id: "Fill-4",
    fill: "#FFFFFF"
  })));
};
FacebookBrand.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
FacebookBrand.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = FacebookBrand;